<template>
    <li v-bind:key="pack.id">
        <div class="thumb">
            <img :src="pack.image" :alt="pack.name" />
        </div>
        <div class="content">
            <div>
                <div class="title">
                    {{ pack.name }}
                </div>

                <div class="address">
                    {{ pack.address }}
                </div>

                <div class="datetime">
                    <span class="time" v-if="pack.recinto">{{ pack.recinto.name }}</span>
                    <br>
                    <span class="date">{{ pack.location }}</span>
                </div>

                <div class="price">
                    {{ $t('eventos.precio_desde') }}
                    <strong>{{ pack.precio_minimo | formatear_precio }}</strong>
                </div>
            </div>

            <footer>
                <div>
                    <div class="row">
                        <div class="col-auto flex-fill my-2 my-lg-3">
                            <router-link
                                class="button w-100"
                                :to="{ name: 'front.packs.show', params: { slug: pack.slug } }"
                            >
                                <span>
                                    {{ $t('partidos.comprar') }}
                                </span>
                            </router-link>                                                                    
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </li>
</template>

<script>
export default {
    props: {
        pack: {
            type: Object,
            required: true
        }
    }
}
</script>